import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import PredictionTypeTableDto from '../dto/PredictionTypeTableDto';

class PredictionTypeTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'predictionTypeTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<PredictionTypeTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, { session, firstResult, maxResults })
				.then(response => resolve(new GenericTableDto().setup(response.data, PredictionTypeTableDto)))
				.catch(reject);
		});
	}
}

export default new PredictionTypeTableService();
